import SectionForm from "../components/SectionsForm";


const AddSections = () => {
  
  return (
    <div className="card-add-change-request"><SectionForm /></div>
  );
}
export default AddSections;